import { fetchDataPromise } from '../index';

export const loginAccess = (resolve, reject, account, password, code = null) => {
  let reqBodyCondi = {};
  if (account !== null && account !== undefined) {
    reqBodyCondi = {
      acc: account,
      pwd: password,
      code: code,
    }
  }

  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/login', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyCondi)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('doLogin response format error.');
      }
    } else {
      reject('doLogin response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const doForgetPassword = (resolve, reject, email) => {
  let reqBodyCondi = {};

  reqBodyCondi = {
    email: email
  }

  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/forgetpassword', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyCondi)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('forgetpassword response format error.');
      }
    } else {
      reject('forgetpassword response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const doResendCode = (resolve, reject, account, password) => {
  let requestBody = {};
  if (account) {
    requestBody = {
      acc: account,
      pwd: password
    }
  }

  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/send-verification-code', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(requestBody)
  });

  fetch(req)
      .then((response) => {
        if (response.ok) {
          if (response.json) {
            resolve(response.json());
          } else {
            reject('resend-code response format error.');
          }
        } else {
          reject('resend-code response error.');
        }
      }).catch((err) => {
    reject(err);
  });
}

export const doResetPassword = (resolve, reject, token, accountSeq, oldPassword, newPassword) => {
  let reqBodyCondi = {};
  if (accountSeq) {
    reqBodyCondi = {
      accSeq: accountSeq,
      oldPwd: oldPassword,
      pwd: newPassword
    }
  }

  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/resetpassword', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyCondi)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('doResetPassword response format error.');
      }
    } else {
      reject('doResetPassword response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const doChangeName = (resolve, reject, token, reqBodyObj) => {
  
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/editaccount', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization' : token,
        'Content-Type' : 'application/json'
      },
      body: JSON.stringify(reqBodyObj)
    });
  
    fetchDataPromise(req, 'editAccount', resolve, reject)
  
}

export const createAccount = (resolve, reject, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/createaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'createAccount', resolve, reject);
}

export const getCompleteTutorialData = (resolve, reject, token, tableNumber) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + "/getcompletetutorialdata?tableNumber=" + tableNumber, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
  });

  fetchDataPromise(req, 'getCompleteTutorialData', resolve, reject);
}